import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import "./styles/Navbar.css";
import logo from "../assets/logo.png";

const Navbar = () => {
  const [open, setOpen] = useState(false);

  const closeMenu = () => setOpen(false);

  // ✅ Open login portal
  const handleLogin = () => {
    window.open("https://portal.sparshcargo.in/", "_blank");
  };

  return (
    <nav className="navbar">
      
      {/* Left Logo */}
      <div className="nav-left">
        <img src={logo} alt="SCPL" />
        <span>SCPL</span>
      </div>

      {/* Hamburger */}
      <div className="hamburger" onClick={() => setOpen(!open)}>
        <span></span>
        <span></span>
        <span></span>
      </div>

      {/* Center Links */}
      <ul className={`nav-links ${open ? "open" : ""}`}>
        <li>
          <NavLink to="/" onClick={closeMenu}>Home</NavLink>
        </li>

        <li>
          <NavLink to="/tracking" onClick={closeMenu}>Tracking</NavLink>
        </li>

        <li>
          <NavLink to="/contact" onClick={closeMenu}>Contact Us</NavLink>
        </li>

        <li>
          <NavLink to="/about" onClick={closeMenu}>About Us</NavLink>
        </li>
      </ul>

      {/* Right Side */}
      <div className="nav-right">

        {/* ✅ Click to Call */}
        <a href="tel:9911176906" className="phone">
          📞 9911176906
        </a>

        {/* ✅ Login Button with URL */}
        <button className="nav-btn" onClick={handleLogin}>
          Login
        </button>

      </div>
    </nav>
  );
};

export default Navbar;